import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const SwitchContainer = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  position: 'relative',
});
